/**
 * useMemberProfilePort — port-factory hook returning a stable
 * {@link MemberProfilePort} for production composition (034 US2, T025).
 *
 * `Composition` calls this once at the root and passes the instance through
 * `PortsProvider` as the `memberProfile` slot. Like `useMemberCasesPort` /
 * `useMyDataPort` (and unlike the retired demo adapter), it constructs the REAL
 * tRPC-backed reader (`TrpcMemberProfileReader` over `member.profile.get`) — the
 * member's cookie session authenticates the same-origin request, so no bearer
 * source is wired.
 *
 * Test harnesses do NOT call this factory — the `memberProfile` slot is supplied
 * with a fixture port explicitly (renderAppWithPorts), so the missing-port stub
 * semantics hold for compositions that omit it.
 *
 * Owned by feature 018-omat-tiedot; reshaped by 034-member-is-reads US2.
 */

import { useState } from 'react';
import type { MemberProfilePort } from '../member-profile/MemberProfilePort.js';
import { TrpcMemberProfileReader } from '../member-profile/TrpcMemberProfileReader.js';
import { createWebTrpcClient } from '../trpc/client.js';

export function useMemberProfilePort(): MemberProfilePort {
  const [port] = useState<MemberProfilePort>(
    () => new TrpcMemberProfileReader(createWebTrpcClient()),
  );

  return port;
}
